/**
 * Resolves a path under the CRA `public/` folder to an absolute URL (respects `PUBLIC_URL`).
 * Use for local assets during development or when serving from `public/` without CDN.
 */
export function localPublicAssetUrl(pathFromWebRoot: string): string {
  const path = pathFromWebRoot.startsWith('/') ? pathFromWebRoot : `/${pathFromWebRoot}`
  const base = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '')
  const combined = `${base}${path}`
  if (typeof window !== 'undefined' && window.location?.href) {
    try {
      return new URL(combined, window.location.href).href
    } catch {
      return combined
    }
  }
  return combined
}
